import { render, staticRenderFns } from "./ColorsEdit.vue?vue&type=template&id=42697399"
import script from "./ColorsEdit.vue?vue&type=script&lang=js"
export * from "./ColorsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports